export default "__VITE_ASSET__407d4a63__"